/**
 * Report-Definition für das Scope Statement.
 *
 * Übersetzt den gespeicherten Markdown-Stand des Scope Statements in ein
 * {@link ReportDocument}. Analog zu {@link ./projektauftragReport}: deklariert
 * nur den Inhalt, der gemeinsame Renderer erzeugt das PDF.
 */
import {
  buildDocument,
  buildSection,
  textBlock,
  type ReportDocument,
} from '../../../lib/pdf/reportModel';

export interface ScopeStatementReportInput {
  /** Frei verfasstes Scope Statement (Markdown-Quelltext). */
  scopeStatement: string;
}

export function buildScopeStatementReport(input: ScopeStatementReportInput): ReportDocument {
  return buildDocument([
    buildSection('Scope Statement', [
      textBlock('Projektumfang', input.scopeStatement),
    ]),
  ]);
}
